export default "__VITE_ASSET__CVXowsox__"